import React from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import TextareaAutosize from "react-textarea-autosize";
import UploadImage from "@/__core/helpers/components/UploadImage";
import { sharedFormStyles } from "@/__core/styles/sharedFormStyles";
import LabeledField from "@/__core/components/LabeledField";

interface AdditionalFormData {
  image1?: string;
  image2?: string;
  notes?: string;
  relative_info?: string;
}

interface AdditionalInfoSectionProps {
  formData: AdditionalFormData;
  canEdit: boolean;
  onChange: (field: string, value: any) => void;
  onImageAdded: (field: "image1" | "image2") => (imageFile: any) => Promise<void>;
  onImageRemoved: (field: "image1" | "image2") => () => void;
}

const AdditionalInfoSection: React.FC<AdditionalInfoSectionProps> = ({
  formData,
  canEdit,
  onChange,
  onImageAdded,
  onImageRemoved,
}) => {
  return (
    <Paper sx={{ ...sharedFormStyles.formCard, mb: 2 }}>
      <Typography sx={sharedFormStyles.sectionTitle}>Thông tin bổ sung</Typography>

      <Box
        sx={sharedFormStyles.additionalImagesContainer}
      >
        <Box sx={sharedFormStyles.additionalImageItem}>
          <Box sx={sharedFormStyles.additionalImageCard}>
            <Typography sx={sharedFormStyles.additionalImageTitle}>
              Hình ảnh 1
            </Typography>
            <Box sx={sharedFormStyles.additionalImageUploadWrapper}>
              <UploadImage
                currentImageUrl={formData.image1 || undefined}
                onFileAdded={onImageAdded("image1")}
                onFileRemoved={onImageRemoved("image1")}
                height={sharedFormStyles.additionalImageUploadHeight}
                background={sharedFormStyles.additionalImageUploadBackground}
                borderRadius={sharedFormStyles.additionalImageUploadBorderRadius}
              />
            </Box>
          </Box>
        </Box>

        <Box sx={sharedFormStyles.additionalImageItem}>
          <Box sx={sharedFormStyles.additionalImageCard}>
            <Typography sx={sharedFormStyles.additionalImageTitle}>
              Hình ảnh 2
            </Typography>
            <Box sx={sharedFormStyles.additionalImageUploadWrapper}>
              <UploadImage
                currentImageUrl={formData.image2 || undefined}
                onFileAdded={onImageAdded("image2")}
                onFileRemoved={onImageRemoved("image2")}
                height={sharedFormStyles.additionalImageUploadHeight}
                background={sharedFormStyles.additionalImageUploadBackground}
                borderRadius={sharedFormStyles.additionalImageUploadBorderRadius}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      <Grid container rowSpacing={1} sx={sharedFormStyles.additionalTextGrid}>
        <Grid size={{ xs: 12 }}>
              <LabeledField 
              label="Ghi chú" 
              labelWidth={130}
              alignItems="start"
              >


                <TextareaAutosize
                    value={formData.notes || ""}
                    onChange={(e) => onChange("notes", e.target.value)}
                    disabled={!canEdit}
                    minRows={2}
                    style={sharedFormStyles.additionalTextarea(canEdit)}
                />
              </LabeledField>

        </Grid>
        <Grid size={{ xs: 12 }}>
          <LabeledField 
          label="Thông tin người thân" 
          labelWidth={130} 
          alignItems="start">
          <TextareaAutosize
            value={formData.relative_info || ""}
            onChange={(e) => onChange("relative_info", e.target.value)}
            disabled={!canEdit}
            minRows={2}
            style={sharedFormStyles.additionalTextarea(canEdit)}
          />
          </LabeledField>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default AdditionalInfoSection;
